import React from 'react';
import type { FC } from 'react';
import { Box } from '@wix/cli-ui-kit';
import type { BackOfficeExtensionContainer } from '@wix/extensions-data-client';
import type { ComponentGenerationResult } from '@wix/gena';
import { GenerationSuccessMessage } from '../../GenerationSuccessMessage.js';

export const DashboardMenuPluginGeneratedNote: FC<{
  backofficeMenuItem: BackOfficeExtensionContainer;
  generatedFiles: ComponentGenerationResult['newFiles'];
}> = ({ generatedFiles }) => {
  return (
    <Box flexDirection="column">
      <GenerationSuccessMessage
        extensionType={'dashboard menu plugin'}
        generatedFiles={generatedFiles}
        learnMoreUrl="https://dev.wix.com/docs/go-headless"
      />
    </Box>
  );
};
